import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const Testimonials = () => {
  const testimonials = [];


  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-3 md:mb-4">
            What Our Users Say
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Real experiences from real people in our community
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="bg-card rounded-lg p-6 md:p-8 shadow-elevation-2 transition-smooth hover:shadow-elevation-3">
            
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, index) =>
              <Icon
                key={index}
                name="Star"
                size={18}
                color="var(--color-accent)"
                strokeWidth={2}
                fill="var(--color-accent)" />

              )}
              </div>

              <p className="font-body text-sm md:text-base text-foreground mb-6 line-clamp-4">
                "{testimonial?.comment}"
              </p>

              <div className="flex items-center space-x-3 pt-4 border-t border-border">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover" />
                
                </div>

                <div className="flex-1 min-w-0">
                  <p className="font-body font-medium text-sm md:text-base text-foreground truncate">
                    {testimonial?.name}
                  </p>
                  <p className="font-caption text-xs text-muted-foreground truncate">
                    {testimonial?.role}
                  </p>
                  <div className="flex items-center space-x-1 mt-1">
                    <Icon name="MapPin" size={12} color="var(--color-muted-foreground)" strokeWidth={2} />
                    <span className="font-caption text-xs text-muted-foreground">
                      {testimonial?.location}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default Testimonials;